module.exports = __webpack_public_path__ + "static/Website_Logo-30a7d01abd764c2ad17629b8d94379af.png";